// PRD §3.3 — Auction request/response schemas.
import { z } from 'zod';
export const AUCTION_STATUSES = ['LISTED', 'SOLD', 'WITHDRAWN'];
export const CreateAuctionRequestSchema = z
    .object({
    animal_id: z.string().uuid(),
    fair_id: z.string().min(1).max(60).default('silleda'),
    start_price: z.number().nonnegative().optional(),
})
    .strict();
export const UpdateAuctionRequestSchema = z
    .object({
    final_price: z.number().nonnegative().optional(),
    buyer_id: z.string().uuid().optional(),
    status: z.enum(AUCTION_STATUSES).optional(),
})
    .strict();
export const AuctionResponseSchema = z.object({
    id: z.string().uuid(),
    animal_id: z.string().uuid(),
    fair_id: z.string(),
    start_price: z.number().nullable(),
    final_price: z.number().nullable(),
    buyer_id: z.string().uuid().nullable(),
    status: z.enum(AUCTION_STATUSES),
    listed_at: z.string().datetime({ offset: true }),
    sold_at: z.string().datetime({ offset: true }).nullable(),
});
export const AuctionListResponseSchema = z.object({
    rows: z.array(AuctionResponseSchema),
});
export const AuctionListQuerySchema = z.object({
    fair_id: z.string().min(1).max(60).optional(),
    status: z.enum(AUCTION_STATUSES).optional(),
    limit: z.coerce.number().int().positive().max(200).default(50),
});
//# sourceMappingURL=auction.js.map